/// <reference path="../objects/classes/basecontroller.ts" />
/// <reference path="../services/composition.service.ts" />
/// <reference path="../objects/interfaces/iproduct.ts" />

module App.Controllers {
    export interface IOverviewController extends IBaseController {

    }

    export class OverviewController extends BaseController implements IOverviewController {
        static controllerId = 'overviewController';

        static $inject = [
            '$rootScope',
            '$scope',
            '$q',
            '$stateParams',
            Services.SessionService.serviceId,
            Services.NavigationService.serviceId,
            Services.CompositionService.serviceId,
            SnackbarFactory.factoryId,
            'ngDialog',
            '$sce',
            Services.ValidationService.serviceId,
            Services.AccountService.serviceId
        ];

        selectedDateTime: string;
        licensePlate: string;
        maintenanceProducts: Interfaces.IProduct[];
        actionsProducts: Interfaces.IProduct[];
        location: string;
        replacementVehicle: string;
        pickupAddress: string;
        privacy: boolean;
        nextClicked = false;
        privacyStatement: string;
        prevStepNumber: string;
        showEditButton: boolean = false;

        constructor(public $rootScope: Interfaces.IAppRootScope,
            $scope: ng.IScope,
            $q: ng.IQService,
            $stateParams: ng.ui.IStateParamsService,
            sessionService: App.Interfaces.ISessionService,
            navigationService: App.Interfaces.INavigationService,
            compositionService: Interfaces.ICompositionService,
            public snackbarFactory: Interfaces.ISnackbarFactory,
            ngDialog: any,
            $sce: any, 
            validationService: Interfaces.IValidationService,
            accountService: Interfaces.IAccountService) {
            super($rootScope, $scope, $q, sessionService, navigationService, compositionService, ngDialog, $sce, validationService, accountService, snackbarFactory);

            this.privacy = false;
            this.privacyStatement = App.Variables.privacyStatement;
            this.showEditButton = (Variables.configuratorType != Constants.configuratorTypes.tyreChangeAaPipelineName && Variables.configuratorType != Constants.configuratorTypes.tyreChangePipelineName);

            var composition = this.sessionService.composition;

            this.selectedDateTime = moment(composition.selectedDate).format('dddd DD MMMM') + ' ' + composition.selectedTime;
            this.licensePlate = composition.licensePlate;

            this.prevStepNumber = (sessionService.maxStepNumber - 1).toString();

            if (composition.selectedProducts != null) {
                this.maintenanceProducts = composition.selectedProducts.filter((p) => { return p.type != Constants.productTypes.actions });
                this.actionsProducts = composition.selectedProducts.filter((p) => { return p.type == Constants.productTypes.actions && p.name.indexOf("wachten") == -1 });
            }

            this.location = composition.storeName;

            if (composition.selectedReplacementVehicle != null) {
                this.replacementVehicle = composition.selectedReplacementVehicle.name;

                if (composition.collectAddress != null)
                    this.pickupAddress = composition.collectAddress.street + composition.collectAddress.houseNumber + composition.collectAddress.postCode + + composition.collectAddress.city;
            }
        }

        gotoNextStep() {
            if (!this.privacy) {
                this.snackbarFactory.show('Ga akkoord met het privacy statement', 4000);
                return;
            }

            if (!this.nextClicked) {
                this.nextClicked = true;

                this.setCompositionValue(Constants.apiServiceStateCalls.privacyCheck, this.privacy, true).then(
                    (result: Classes.IComposition) => {

                    }).catch((err) => {
                        this.snackbarFactory.show('Fout met opslaan, probeer het opnieuw. Foutcode: ' + err, 4000);
                        console.log('error setCompositionValue overview: ' + JSON.stringify(err));
                    }).finally(() => {
                        this.nextClicked = false;
                    });
            }
        }

        goBackToStep() {
            this.previousStep();
        }

    }

    app.controller(OverviewController.controllerId, OverviewController);

}